module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2078029388/src/~/babel-runtime/core-js/object/assign.js
// module id = saYs
// module chunks = 6